import React, { useState, useEffect } from 'react';
import HomePageContent from './HomePageContent';

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return <HomePageContent variant={isMobile ? 'mobile' : 'desktop'} />;
};

export default HomePage;
